import {
  STORE_TICKETS, STORE_TICKET
} from '../mutation-types'
export default {
  [STORE_TICKETS] (state, payload) {
    state.tickets = payload
  },
  [STORE_TICKET] (state, payload) {
    state.ticket = payload
  }
}
